import { Box, SxProps } from '@mui/material';
import {
    MRT_GlobalFilterTextField as GlobalFilterTextField,
    MRT_RowData,
    MRT_ShowHideColumnsButton as ShowHideColumnsButton,
    MRT_TableInstance,
} from 'material-react-table';
import { FC, ReactElement } from 'react';
import ToggleMoreFiltersButton from '@shared/components/others/ToggleMoreFiltersButton/ToggleMoreFiltersButton';

interface UtmsToolbarProps {
    table: MRT_TableInstance<MRT_RowData>;
    TagSelectorComponent?: ReactElement;
    enableToggleFiltersButton?: boolean;
    ModuleSelectorComponent?: ReactElement;
    enableGlobalFilterTextField?: boolean;
    GlobalFilterTextFieldComponent?: ReactElement;
    enableShowHideColumnsButton?: boolean;
    AdditionalToolbarComponent?: ReactElement;
    sx?: SxProps;
}

const UtmsTableToolbar: FC<UtmsToolbarProps> = ({
    table,
    TagSelectorComponent,
    enableGlobalFilterTextField,
    enableShowHideColumnsButton,
    enableToggleFiltersButton,
    ModuleSelectorComponent,
    AdditionalToolbarComponent,
    GlobalFilterTextFieldComponent,
    sx,
}) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, ...sx }}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                {enableGlobalFilterTextField &&
                    (GlobalFilterTextFieldComponent || (
                        <GlobalFilterTextField
                            table={table}
                            sx={{ maxWidth: 224, minHeight: 42, '& .MuiInputBase-root': { height: 42 } }}
                        />
                    ))}
                {ModuleSelectorComponent}
                {TagSelectorComponent}
                {enableToggleFiltersButton && (
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <ToggleMoreFiltersButton table={table} />
                    </Box>
                )}
                {AdditionalToolbarComponent}
            </Box>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                {enableShowHideColumnsButton && (
                    <Box>
                        <ShowHideColumnsButton table={table} />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default UtmsTableToolbar;
